import React, { useState, useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaStar, FaBookmark, FaMapMarkerAlt, FaLanguage, FaShoppingBag } from 'react-icons/fa';
import { useBookmarkContext } from '../../Contexts/BookmarkProvider';
import { LoginContext } from '../../Contexts/LoginContext';
import { Navigate } from 'react-router-dom';
import { useFloatingChat } from '../../Contexts/FloatingChatContext';
import Loader from '../../Components/utils/Loader';
import DummyImage from '../../images/pngs/seller.png';
import { showToast } from '../../Components/utils/ShowToast';

const BookmarkSellers = () => {
  const { isLogin } = useContext(LoginContext);
  const { bookmarkedSellers, removeBookmark, loading, actionLoading, fetchBookmarkedSellers } = useBookmarkContext();
  const { openFloatingChat } = useFloatingChat();
  const [showModal, setShowModal] = useState(false);
  const [selectedSellerId, setSelectedSellerId] = useState(null);

  useEffect(() => {
    if (isLogin)
      fetchBookmarkedSellers();
  }, [isLogin]);

  if (isLogin === false) {
    showToast('Please login to view bookmarked sellers', 'warning');
    return <Navigate to="/signin" />;
  }

  if (loading) {
    return <Loader type="simple" />;
  }

  const handleBookmarkClick = (sellerId) => {
    setSelectedSellerId(sellerId);
    setShowModal(true);
  };

  const handleRemoveBookmark = () => {
    removeBookmark(selectedSellerId);
    setShowModal(false);
  };

  return (
    <div className="bookmarkSellersContainer">
      <section className="mainSection">
        <h1 className="pageMainHeading">Bookmarked Sellers</h1>
        {bookmarkedSellers.length > 0 ? (
          <div className="bookmarkSellersGrid">
            {bookmarkedSellers.map((seller) => {
              const sellerId = seller?._id || seller?.id;
              const displayName = seller.displayName || seller.fullName;
              const location = seller.sellerAddress ? `${seller.sellerAddress.city}, ${seller.sellerAddress?.country?.name}` : 'N/A';
              return (
                <div key={sellerId} className="bookmarkSellerCard">
                  <div className="bookmarkSellerCardHeader">
                    <Link to={`/vendorDetail/${sellerId}`} className="bookmarkSellerCardImageLink">
                      <img
                        src={seller?.profileImage || DummyImage}
                        alt={displayName}
                        className="bookmarkSellerCardImage"
                      />
                    </Link>
                    <div className="bookmarkSellerCardTitle">
                      <Link to={`/vendorDetail/${sellerId}`} className="bookmarkSellerNameLink">
                        {displayName}
                      </Link>
                      <div className="bookmarkSellerRating">
                        <FaStar className="bookmarkSellerStar" />
                        <span>{seller.rating?.toFixed(1) || '0.0'}</span>
                        <span className="bookmarkSellerReviews">({seller.noOfReviews || 0} reviews)</span>
                      </div>
                    </div>
                    <button
                      type="button"
                      className={`bookmarkSellerBookmarkBtn ${actionLoading[sellerId] ? 'loading' : ''}`}
                      onClick={() => handleBookmarkClick(sellerId)}
                      title="Remove from bookmarks"
                    >
                      {actionLoading[sellerId] ? <Loader type="miniPlus" /> : <FaBookmark className="filled" />}
                    </button>
                  </div>
                  <div className="bookmarkSellerCardMeta">
                    <span className="bookmarkSellerMetaItem">
                      <FaLanguage /> {seller.userId?.languages || 'N/A'}
                    </span>
                    <span className="bookmarkSellerMetaItem">
                      <FaMapMarkerAlt /> {location}
                    </span>
                    <span className="bookmarkSellerMetaItem">
                      <FaShoppingBag /> {seller.productsSold || 0} orders completed
                    </span>
                  </div>
                  <p className="bookmarkSellerDescription">{seller.description || 'No description available'}</p>
                  <div className="bookmarkSellerCardActions">
                    <Link to={`/vendorDetail/${sellerId}`} className="bookmarkSellerViewProfile">
                      View Profile
                    </Link>
                    <button className="bookmarkSellerContactBtn" onClick={() => openFloatingChat(seller.userId._id)}>
                      Contact Seller
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <p className="no-items">Nothing to show here...</p>
        )}
      </section>

      {showModal && (
        <div className="modalOverlay">
          <div className="modalContent">
            <h2>Remove Bookmark</h2>
            <p>Are you sure you want to remove this seller from bookmarks?</p>
            <div className="modalButtons">
              <button
                className="removeBtn"
                onClick={handleRemoveBookmark}
                disabled={actionLoading[selectedSellerId]}
              >
                {actionLoading[selectedSellerId] ? 'Removing...' : 'Remove'}
              </button>
              <button className="cancelBtn" onClick={() => setShowModal(false)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BookmarkSellers;